(function () {
  'use strict';

  // ============== CONFIG ==============
  var DELAY_MATCH = [
    'cdn.shopify.com/shopifycloud/shopify-xr-js/',
    'shopify-xr.en.js',

    // Meta / Facebook
    'facebook.net/en_US/fbevents.js',
    'facebook.net/signals/config',
    'www.facebook.com/tr/',
    

    // Shopify portable wallets (MODULE script)
    'preview-bar-modules.js',
    'shopifycloud/portable-wallets/latest/portable-wallets',
    "googletagmanager",
    "gtag/js",
    "facebook.net",
    "analytics",
    "portable-wallets",
    "shopifycloud"
  ];

  // Theme placeholder scripts like:
  // <script type="text/djava" data-src="..."></script>
  // IMPORTANT: must match the actual type used in your theme.
  var STATIC_DELAY_SELECTOR = 'script[type="text/djava"][data-src]';

  var LOAD_FALLBACK_MS = 3000;
  var HARD_FALLBACK_MS = 10000;

  // If true, allow loading; if false, intercept + queue
  var ALLOW_LOAD = false;

  var queuedScripts = [];   // dynamically injected scripts we delay
  var queuedStatic = [];    // theme placeholder scripts we delay (DOM order)
  var fired = false;

  // ============== HELPERS ==============
  function shouldDelay(url) {
    if (!url) return false;
    url = String(url);
    for (var i = 0; i < DELAY_MATCH.length; i++) {
      if (url.indexOf(DELAY_MATCH[i]) !== -1) return true;
    }
    return false;
  }

  function scheduleIdle(fn) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, 1);
    }
  }

  function snapshotAttrs(node) {
    var out = [];
    if (!node || !node.attributes) return out;
    for (var i = 0; i < node.attributes.length; i++) {
      var a = node.attributes[i];
      out.push([a.name, a.value]);
    }
    return out;
  }

  function getScriptType(node) {
    try {
      var t = (node && (node.type || (node.getAttribute && node.getAttribute('type')))) || '';
      return String(t || '').toLowerCase();
    } catch (e) {
      return '';
    }
  }

  // portable-wallets is an ES module (uses import.meta)
  function isModuleUrl(src) {
    return !!(src && String(src).indexOf('shopifycloud/portable-wallets/latest/portable-wallets') !== -1);
  }

  function queueScript(node, src) {
    var t = getScriptType(node);
    queuedScripts.push({
      src: src,
      attrs: snapshotAttrs(node),
      type: t,
      text: (node && (node.text || node.textContent)) ? (node.text || node.textContent) : ''
    });
  }

  // ============== STATIC PLACEHOLDERS ==============
  function collectStaticPlaceholders() {
    try {
      var nodes = document.querySelectorAll(STATIC_DELAY_SELECTOR);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        var src = n.getAttribute('data-src');
        if (!src) continue;

        queuedStatic.push({
          src: src,
          attrs: snapshotAttrs(n),
          type: getScriptType(n) // likely "text/djava" but keep anyway
        });

        // Remove placeholder so theme loader can’t pick it up early
        if (n.parentNode) n.parentNode.removeChild(n);
      }
    } catch (e) {}
  }

  // Call ASAP
  collectStaticPlaceholders();

  // Watch for placeholders added later
  var moStatic = null;
  try {
    moStatic = new MutationObserver(function (mutations) {
      if (ALLOW_LOAD) return;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < (m.addedNodes || []).length; j++) {
          var n = m.addedNodes[j];
          if (!n || !n.tagName) continue;
          if (n.tagName.toUpperCase() !== 'SCRIPT') continue;

          var type = getScriptType(n);
          // We only capture your placeholder type
          if (type === 'text/djava') {
            var src = n.getAttribute('data-src');
            if (src) {
              queuedStatic.push({
                src: src,
                attrs: snapshotAttrs(n),
                type: type
              });
              if (n.parentNode) n.parentNode.removeChild(n);
            }
          }
        }
      }
    });
    moStatic.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  // ============== INTERCEPT DYNAMIC INSERTS ==============
  var origAppendChild = Node.prototype.appendChild;
  var origInsertBefore = Node.prototype.insertBefore;

  function interceptNodeInsert(original) {
    return function (child, ref) {
      try {
        if (!ALLOW_LOAD && child && child.tagName && child.tagName.toUpperCase() === 'SCRIPT') {
          var src = child.src || (child.getAttribute && child.getAttribute('src'));
          if (shouldDelay(src)) {
            queueScript(child, src);
            return original.call(this, document.createComment('delayed-script ' + src), ref || null);
          }
        }
      } catch (e) {}
      return original.call(this, child, ref || null);
    };
  }

  Node.prototype.appendChild = interceptNodeInsert(origAppendChild);
  Node.prototype.insertBefore = interceptNodeInsert(origInsertBefore);

  // setAttribute('src', ...)
  var origSetAttr = Element.prototype.setAttribute;
  Element.prototype.setAttribute = function (name, value) {
    try {
      if (!ALLOW_LOAD && this.tagName && this.tagName.toUpperCase() === 'SCRIPT' && name === 'src' && shouldDelay(value)) {
        queueScript(this, value);
        return origSetAttr.call(this, name, ''); // block fetch
      }
    } catch (e) {}
    return origSetAttr.call(this, name, value);
  };

  // script.src assignment
  try {
    var descSrc = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, 'src');
    if (descSrc && descSrc.set) {
      Object.defineProperty(HTMLScriptElement.prototype, 'src', {
        get: descSrc.get,
        set: function (value) {
          if (!ALLOW_LOAD && shouldDelay(value)) {
            queueScript(this, value);
            return descSrc.set.call(this, ''); // block fetch
          }
          return descSrc.set.call(this, value);
        }
      });
    }
  } catch (e) {}

  // ============== RELEASE ON INTERACTION ==============
  function appendScriptWithMeta(item, ondone) {
    var s = document.createElement('script');

    // Preserve attributes except src/type (we’ll set those)
    for (var j = 0; j < (item.attrs || []).length; j++) {
      var pair = item.attrs[j];
      if (!pair || !pair[0]) continue;
      var key = String(pair[0]).toLowerCase();
      if (key === 'src' || key === 'type') continue;
      try { s.setAttribute(pair[0], pair[1]); } catch (e) {}
    }

    // ✅ Module handling:
    // - If original was type="module", preserve it
    // - OR if URL is portable-wallets, force module (covers cases where original type wasn’t present)
    var originalType = (item.type || '').toLowerCase();
    if (originalType === 'module' || isModuleUrl(item.src)) {
      s.type = 'module';
    }

    // after interaction, don’t block the main thread
    s.async = true;

    if (item.src) {
      s.src = item.src;
      s.onload = s.onerror = function () { ondone && ondone(); };
      document.head.appendChild(s);
    } else {
      // inline
      s.text = item.text || '';
      document.head.appendChild(s);
      ondone && ondone();
    }
  }

  function loadStaticQueueThenDynamicQueue() {
    // Allow loading now (prevents self-blocking)
    ALLOW_LOAD = true;
    if (moStatic) try { moStatic.disconnect(); } catch (e) {}

    // 1) Load static placeholders (DOM order captured)
    var si = 0;
    function nextStatic() {
      var item = queuedStatic[si++];
      if (!item) return nextDynamic();

      // Static placeholders are just URLs; load as script.
      // If any static placeholder is module, you can force it by matching URL (like portable-wallets).
      appendScriptWithMeta(
        { src: item.src, attrs: item.attrs || [], type: '', text: '' },
        function () { scheduleIdle(nextStatic); }
      );
    }

    // 2) Load delayed dynamic scripts (in order)
    var di = 0;
    function nextDynamic() {
      var item = queuedScripts[di++];
      if (!item) return;

      appendScriptWithMeta(item, function () {
        scheduleIdle(nextDynamic);
      });
    }

    scheduleIdle(nextStatic);
  }

  function fire() {
    if (fired) return;
    fired = true;
    removeTriggers();
    scheduleIdle(loadStaticQueueThenDynamicQueue);
  }

  function addTriggers() {
    var events = ['mousemove', 'touchstart', 'scroll', 'keydown', 'click'];
    for (var i = 0; i < events.length; i++) {
      window.addEventListener(events[i], fire, { passive: true, once: true });
    }
  }

  function removeTriggers() {
    var events = ['mousemove', 'touchstart', 'scroll', 'keydown', 'click'];
    for (var i = 0; i < events.length; i++) {
      window.removeEventListener(events[i], fire, false);
    }
  }

  addTriggers();

  // Optional fallbacks (you had these commented out — enable if you want “always load eventually”)
  // window.addEventListener('load', function () { setTimeout(fire, LOAD_FALLBACK_MS); });
  // setTimeout(fire, HARD_FALLBACK_MS);


})();


(function () {
  'use strict';

  var LINK_ID = 'shopify-accelerated-checkout-styles';
  var TARGET = '/cdn/shopifycloud/portable-wallets/latest/accelerated-checkout-backwards-compat.css';

  var ALLOW = false;
  var queuedHref = null;
  var fired = false;

  function isTargetLink(el) {
    if (!el || !el.tagName || el.tagName.toUpperCase() !== 'LINK') return false;
    if (el.id === LINK_ID) return true;
    var href = el.getAttribute('href') || el.href || '';
    return String(href).indexOf(TARGET) !== -1;
  }

  function blockLink(el, href) {
    if (!el || el.__blockedAccelCSS) return;
    queuedHref = href || el.getAttribute('href') || el.href;
    // prevent request by removing href before it can resolve
    try { el.setAttribute('href', ''); } catch (e) {}
    try { el.href = ''; } catch (e) {}
    // also make it non-applying
    try { el.media = 'print'; } catch (e) {}
    el.__blockedAccelCSS = true;
  }

  // Intercept href being set (best chance to stop the request)
  var origSetAttr = Element.prototype.setAttribute;
  Element.prototype.setAttribute = function (name, value) {
    try {
      if (!ALLOW && name === 'href' && this.tagName && this.tagName.toUpperCase() === 'LINK') {
        // If Shopify is setting href for our target CSS, blank it immediately
        var v = String(value || '');
        if ((this.id === LINK_ID) || v.indexOf(TARGET) !== -1) {
          queuedHref = v;
          return origSetAttr.call(this, name, ''); // block
        }
      }
    } catch (e) {}
    return origSetAttr.call(this, name, value);
  };

  // Intercept property assignment link.href = "..."
  try {
    var desc = Object.getOwnPropertyDescriptor(HTMLLinkElement.prototype, 'href');
    if (desc && desc.set) {
      Object.defineProperty(HTMLLinkElement.prototype, 'href', {
        get: desc.get,
        set: function (value) {
          if (!ALLOW) {
            var v = String(value || '');
            if ((this.id === LINK_ID) || v.indexOf(TARGET) !== -1) {
              queuedHref = v;
              return desc.set.call(this, ''); // block
            }
          }
          return desc.set.call(this, value);
        }
      });
    }
  } catch (e) {}

  // Catch if the link node is inserted with href already present
  var mo = null;
  try {
    mo = new MutationObserver(function (muts) {
      if (ALLOW) return;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        for (var j = 0; j < (m.addedNodes || []).length; j++) {
          var n = m.addedNodes[j];
          if (isTargetLink(n)) {
            var href = n.getAttribute('href') || n.href;
            if (href && String(href).indexOf(TARGET) !== -1) {
              blockLink(n, href);
            }
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  function loadNow() {
    if (fired) return;
    fired = true;
    ALLOW = true;
    if (mo) try { mo.disconnect(); } catch (e) {}
    removeTriggers();

    // Restore link if it exists
    var link = document.getElementById(LINK_ID);
    if (link) {
      if (!queuedHref) queuedHref = TARGET; // fallback
      link.rel = 'stylesheet';
      link.media = 'screen';
      link.href = queuedHref;
      return;
    }

    // Or recreate it if Shopify removed it
    if (queuedHref) {
      var l = document.createElement('link');
      l.id = LINK_ID;
      l.rel = 'stylesheet';
      l.media = 'screen';
      l.href = queuedHref;
      l.crossOrigin = 'anonymous';
      document.head.appendChild(l);
    }
  }

  function addTriggers() {
    ['mousemove', 'touchstart', 'scroll', 'keydown', 'click'].forEach(function (e) {
      window.addEventListener(e, loadNow, { passive: true, once: true });
    });
    window.addEventListener('load', function () {
      setTimeout(loadNow, 3000);
    });
  }
  function removeTriggers() {
    ['mousemove', 'touchstart', 'scroll', 'keydown', 'click'].forEach(function (e) {
      window.removeEventListener(e, loadNow, false);
    });
  }

  // In case it already exists when our script runs
  try {
    var existing = document.getElementById(LINK_ID);
    if (existing && isTargetLink(existing)) {
      var href0 = existing.getAttribute('href') || existing.href;
      if (href0 && String(href0).indexOf(TARGET) !== -1) blockLink(existing, href0);
    }
  } catch (e) {}

  addTriggers();
})();


(function () {
  'use strict';

  var ID = 'shopify-accelerated-checkout-styles';
  var applied = false;

  function fix(link) {
    if (!link || link.__cwvFixed) return;
    link.__cwvFixed = true;

    var href = link.getAttribute('href');
    if (!href) return;

    // 1) Make it non-render-blocking
    // (won't apply to screen during initial render)
    link.setAttribute('media', 'print');

    // 2) Preload the CSS (non-render-blocking fetch)
    var preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'style';
    preload.href = href;

    var co = link.getAttribute('crossorigin');
    if (co) preload.setAttribute('crossorigin', co);

    preload.onload = function () {
      if (applied) return;
      applied = true;
      link.setAttribute('media', 'all'); // apply now
    };

    document.head.appendChild(preload);

    // 3) Safety fallback (some browsers may not fire preload onload reliably)
    setTimeout(function () {
      if (applied) return;
      applied = true;
      link.setAttribute('media', 'all');
    }, 2000);
  }

  // If already present
  fix(document.getElementById(ID));

  // If Shopify injects later
  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes || [];
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n && n.tagName && n.tagName.toUpperCase() === 'LINK' && n.id === ID) {
            fix(n);
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();

(function(){
  'use strict';

  // Only load the ENTRY module; it will import its chunks itself.
  var ENTRY = "https://mamaapp.co/cdn/shopifycloud/shop-js/modules/v2/client.init-shop-cart-sync_DuC_-mRw.en.esm.js";

  var loaded = false;

  function loadShopJs(){
    if (loaded) return;
    loaded = true;

    // Remove blocked module tags so they don't run later by mistake
    document.querySelectorAll('script[type="module"][data-src*="/shopifycloud/shop-js/modules/"]').forEach(function(n){
      n.parentNode && n.parentNode.removeChild(n);
    });
    document.querySelectorAll('script[data-shopjs-inline="1"]').forEach(function(n){
      n.parentNode && n.parentNode.removeChild(n);
    });

    // Load after interaction using dynamic import (module-safe)
    var s = document.createElement('script');
    s.type = 'module';
    s.textContent =
      "import('" + ENTRY + "').then(function(){\n" +
      "  window.Shopify?.SignInWithShop?.initShopCartSync?.({fedCMEnabled:true, windoidEnabled:true});\n" +
      "});";
    document.head.appendChild(s);
  }

  ['mousemove','touchstart','scroll','keydown','click'].forEach(function(e){
    window.addEventListener(e, loadShopJs, {passive:true, once:true});
  });

  // fallback (optional)
  // window.addEventListener('load', function(){ setTimeout(loadShopJs, 3000); });
})();